<div class="property-group-section">
  <div class="section-header">
    <h4>Lead Information</h4>
  </div>

  <div class="group-properties">
    @for (attribute of orderedAttributes; track attribute.property) {
      @if (
        attribute.property !== "lead_status" &&
        attribute.property !== "status_notes" &&
        attribute.property !== "viability_rating" &&
        attribute.property !== "approved_loan_amount"
      ) {
        <div class="each-popup-data">
          <span class="label-text">
            {{ getAttributeLabel(attribute) }}
          </span>

          @if (crmStatus || !isEditClicked) {
            <div class="value">
              {{ getDisplayValue(attribute) }}
            </div>
          } @else {
            <div class="editable-property">
              @if (attribute.type === "dropdown") {
                <select
                  [disabled]="
                    attribute.property === 'lead_status' && isActiveFund()
                  "
                  (change)="onDropdownChange(attribute.property, $event)"
                >
                  @for (
                    option of getOptions(attribute.options);
                    track option.label
                  ) {
                    <option
                      [value]="option.value"
                      [selected]="
                        option.value === leadAttributes?.[attribute.property]
                      "
                    >
                      {{ option.label }}
                    </option>
                  }
                </select>
              } @else if (attribute.type === "number") {
                <input
                  type="text"
                  [value]="leadAttributes?.[attribute.property] ?? ''"
                  (input)="onInputChange(attribute.property, $event)"
                />
              } @else {
                <input
                  type="text"
                  [value]="leadAttributes?.[attribute.property]"
                  (input)="onInputChange(attribute.property, $event)"
                />
              }
            </div>
          }
        </div>
      }
    }
  </div>
</div>

@if (showStatusChangePopup) {
  <app-popup
    [heading]="statusWarningHeading"
    [confirmText]="'Confirm'"
    [cancelText]="'Cancel'"
    [popupPosition]="'absolute'"
    (confirmClicked)="onConfirmStatusChange()"
    (cancelClicked)="onCancelStatusChange()"
  >
    <div class="status-warning-popup-content">
      <p class="status-warning-message">
        Are you sure you want to change the status from
        <strong class="status-highlight">{{ previousStatusLabel }}</strong>
        to
        <strong class="status-highlight">{{ newStatusLabel }}</strong
        >?
      </p>
      @if (statusWarningSubtext) {
        <p class="status-warning-subtext">
          {{ statusWarningSubtext }}
        </p>
      }
    </div>
  </app-popup>
}
